import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
import * as actions from '../actions';
import * as c from '../constants';

const formatData = info => {
  const newArr = [];
  info.map(res => {
    if(res.attributes.txnid) {
      newArr.push({
        label: res.attributes.txnid,
        value: res.attributes.txnid,
      })
    }
    return newArr
  })
  return _.uniqBy(newArr, (e) => e.label);
}

const WalletTxn = ({
  setFormData,
  formData,
  logs,
  updating,
  updateWalletTxnId,
  cashInTransactionId
  // onClear,
}) => {
  const setModal = useContext(ModalContext);
  const [isDisabled, setIsDisabled] = useState(true);
  const logData = formatData(logs);

  const handleOnChangeSelect = (key) => (e) => {
    setIsDisabled(false);
    setFormData({
      ...formData,
      [key]: { label: e.value, value: e.value },
    });
  };

  const handleSubmit = () => {
    const args = {
      cash_in_transaction_id: cashInTransactionId,
      txnid: _.get(formData, 'txnid.value'),
    };
    updateWalletTxnId(args, () => {
      // onClear(e);
      setModal({ isOpen: false });
    });
    return args;
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label className="form-label d-flex align-items-center">
            <span className="mr-auto mr-0 text-muted">Transaction</span>
          </label>
          <Select
            placeholder=""
            onChange={handleOnChangeSelect('txnid')}
            options={logData}
            value={_.get(formData, 'txnid')}
          />
        </div>
        <div className="col-12 d-flex justify-content-center mt-2">
          <button
            disabled={isDisabled || updating}
            onClick={handleSubmit}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary "
          >
            Submit
          </button>
        </div>
      </div>
    </Modal.Body>
  );
};

WalletTxn.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  logs: PropTypes.instanceOf(Object).isRequired,
  cashInTransactionId: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
  updateWalletTxnId: PropTypes.instanceOf(Object).isRequired,
  // onClear: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_WALLET_TXN_ID) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(WalletTxn);
